var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	326: () => (loadSingletonVersion("default", "rxjs/operators", false, [4,7,8,2], () => (__webpack_require__.e(620).then(() => (() => (__webpack_require__(3620))))))),
	534: () => (loadSingletonVersion("default", "@angular/router", false, [4,20,3,27], () => (__webpack_require__.e(39).then(() => (() => (__webpack_require__(6039))))))),
	1537: () => (loadSingletonVersion("default", "@angular/platform-browser", false, [4,20,3,27], () => (__webpack_require__.e(55).then(() => (() => (__webpack_require__(436))))))),
	1936: () => (loadSingletonVersion("default", "@siemens/element-ng/loading-spinner", false, [4,48,11,0], () => (__webpack_require__.e(184).then(() => (() => (__webpack_require__(7184))))))),
	1992: () => (loadSingletonVersion("default", "@angular/core", false, [4,20,3,27], () => (__webpack_require__.e(17).then(() => (() => (__webpack_require__(7017))))))),
	2211: () => (loadSingletonVersion("default", "@angular/cdk/overlay", false, [4,20,2,14], () => (__webpack_require__.e(144).then(() => (() => (__webpack_require__(5763))))))),
	3074: () => (loadSingletonVersion("default", "@angular/common", false, [4,20,3,27], () => (__webpack_require__.e(229).then(() => (() => (__webpack_require__(7610))))))),
	3198: () => (loadSingletonVersion("default", "@angular/platform-browser/animations", false, [4,20,3,27], () => (__webpack_require__.e(835).then(() => (() => (__webpack_require__(3835))))))),
	6054: () => (loadSingletonVersion("default", "rxjs", false, [4,7,8,2], () => (__webpack_require__.e(340).then(() => (() => (__webpack_require__(1340))))))),
	8028: () => (loadSingletonVersion("default", "@siemens/element-ng/modal", false, [4,48,11,0], () => (__webpack_require__.e(679).then(() => (() => (__webpack_require__(5679))))))),
	8114: () => (loadSingletonVersion("default", "@siemens/element-ng/skip-links", false, [4,48,11,0], () => (__webpack_require__.e(265).then(() => (() => (__webpack_require__(265))))))),
	9108: () => (loadSingletonVersion("default", "@angular/common/http", false, [4,20,3,27], () => (__webpack_require__.e(396).then(() => (() => (__webpack_require__(8015))))))),
	9930: () => (loadSingletonVersion("default", "@ngx-translate/core", false, [4,16,0,4], () => (__webpack_require__.e(503).then(() => (() => (__webpack_require__(8503))))))),
	5490: () => (loadSingletonVersion("default", "@angular/core/primitives/di", false, [4,20,3,27], () => (__webpack_require__.e(867).then(() => (() => (__webpack_require__(2867))))))),
	7812: () => (loadSingletonVersion("default", "@angular/core/primitives/signals", false, [4,20,3,27], () => (__webpack_require__.e(689).then(() => (() => (__webpack_require__(5689))))))),
	5610: () => (loadSingletonVersion("default", "@angular/animations/browser", false, [4,20,3,27], () => (__webpack_require__.e(147).then(() => (() => (__webpack_require__(1147))))))),
	5521: () => (loadSingletonVersion("default", "@angular/cdk/portal", false, [4,20,2,14], () => (__webpack_require__.e(787).then(() => (() => (__webpack_require__(9168))))))),
	9460: () => (loadSingletonVersion("default", "@angular/animations", false, [4,20,3,27], () => (__webpack_require__.e(791).then(() => (() => (__webpack_require__(7172))))))),
	5309: () => (loadSingletonVersion("default", "@angular/cdk/a11y", false, [4,20,2,14], () => (__webpack_require__.e(840).then(() => (() => (__webpack_require__(2459))))))),
	5926: () => (loadSingletonVersion("default", "@siemens/element-ng/common", false, [4,48,11,0], () => (__webpack_require__.e(551).then(() => (() => (__webpack_require__(1551))))))),
	2562: () => (loadSingletonVersion("default", "tslib", false, [4,2,8,1], () => (__webpack_require__.e(398).then(() => (() => (__webpack_require__(4398)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"15": [
		326,
		1992,
		6054
	],
	"17": [
		326,
		5490,
		6054,
		7812
	],
	"55": [
		9108
	],
	"60": [
		1992,
		2211,
		3074,
		5309,
		5521,
		5926,
		6054
	],
	"144": [
		326
	],
	"168": [
		1992
	],
	"172": [
		1992
	],
	"184": [
		5521,
		9460
	],
	"216": [
		1992,
		3074,
		5610
	],
	"229": [
		6054
	],
	"340": [
		2562
	],
	"396": [
		326,
		6054
	],
	"420": [
		326,
		1537,
		1992,
		3074,
		6054
	],
	"436": [
		1992,
		3074,
		9108
	],
	"459": [
		326,
		1992,
		3074,
		6054
	],
	"528": [
		1992
	],
	"551": [
		326
	],
	"610": [
		1992,
		6054
	],
	"620": [
		2562
	],
	"644": [
		326,
		534,
		1537,
		1936,
		1992,
		2211,
		3074,
		3198,
		6054,
		8028,
		8114,
		9108,
		9930
	],
	"646": [
		1992,
		6054
	],
	"679": [
		5309,
		5521,
		5926
	],
	"763": [
		326,
		1992,
		3074,
		6054
	],
	"803": [
		326,
		1992,
		3074,
		5521,
		6054,
		9460
	],
	"835": [
		5610
	],
	"840": [
		326
	],
	"884": [
		326,
		1992,
		6054
	],
	"932": [
		326,
		1992,
		2211,
		3074,
		6054
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}